package com.esoris.kmpmoout.modules

import com.esoris.kmpmoout.features.expense.expense_form.expenseFormModule
import com.esoris.kmpmoout.features.product.productModule
import org.koin.dsl.module

val featuresModule = module {

}
    .plus(productModule)
    .plus(expenseFormModule)